export class CommentFileModel {
  /**ID файла */
  Id!: number;
  /**Название файла */
  Name!: string;
  /**Размер файла */
  Size!: number;
  /**Ссылка на файл */
  Url!: string;
  /**Обложка файла (для видео) */
  ThumbnailUrl?: string;
  /**Дата загрузки файла */
  DateCreated!: Date;
  /**Файл в обработке */
  IsProccessing: boolean = false;

  constructor(obj?: Partial<CommentFileModel>) {
    Object.assign(this, obj);
  }
}
